import React, { useState, useEffect } from 'react';
import Dialog from '../Dialog/Dialog';
import { IconButton } from '../Button';
import languagesData from '../../data/languages.json';
import { useTranslationKeys } from '../../context/TranslationContext';
// @ts-ignore
import searchIcon from '../../image-assets/icon.search.svg';
// @ts-ignore
import closeIcon from '../../image-assets/icon.close.svg';
import './LanguageDialog.css';

interface Language {
  code: string;
  name: string;
}

interface LanguageDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (language: string) => void;
  existingLanguages: string[];
  onAdd: (language: string) => void;
  isLoading?: boolean;
}

const LanguageDialog: React.FC<LanguageDialogProps> = ({
  isOpen,
  onClose,
  onSelect,
  existingLanguages,
  onAdd,
  isLoading = false
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredLanguages, setFilteredLanguages] = useState<Language[]>(languagesData.languages);
  const { refreshKeys } = useTranslationKeys();

  useEffect(() => {
    const filtered = languagesData.languages.filter((lang: Language) => {
      const matchesSearch = lang.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          lang.code.toLowerCase().includes(searchQuery.toLowerCase());
      const notAlreadyAdded = !existingLanguages.some(existingCode => 
        existingCode.toLowerCase() === lang.code.toLowerCase() ||
        existingCode.toLowerCase() === lang.code.toLowerCase().replace(/-/g, '_')
      );
      return matchesSearch && notAlreadyAdded;
    });
    setFilteredLanguages(filtered);
  }, [searchQuery, existingLanguages]);

  const handleLanguageSelect = async (language: string) => {
    onSelect(language);
    await refreshKeys();
    onClose();
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Add Language"
      showCloseButton={false}
      headerActions={
        <IconButton
          onClick={onClose}
          icon={closeIcon}
          aria-label="Close"
          size="small"
          variant="secondary"
        />
      }
      actions={null}
      className="language-dialog"
      size="small"
    >
      <div className="language-dialog-content">
        <div className="search-container">
          <img src={searchIcon} alt="Search" className="search-icon" />
          <input
            type="text"
            className="search-input"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search languages..."
            autoFocus
          />
        </div>
        <div className="language-options">
          {filteredLanguages.length === 0 ? (
            <div className="no-results">No languages found</div>
          ) : (
            filteredLanguages.map((lang: Language) => (
              <div
                key={lang.code}
                className="language-option"
                onClick={() => handleLanguageSelect(lang.code)}
              >
                <span className="language-name">{lang.name}</span>
                <span className="language-code">{lang.code}</span>
              </div>
            ))
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default LanguageDialog; 